import React, { useEffect, useState } from "react";
import { Info, X } from "lucide-react";

/**
 * Persistent site disclosure banner. Sits above the header on every page
 * for every visitor unless dismissed for the current session.
 *
 * Positioning: MAVULA Investment Ltd is not FCA-authorised, is not a bank,
 * and does not offer investment products. This is a structured purchase
 * pathway. Wording is aligned with the /about and /legal-status pages.
 */
export default function FcaTopBanner() {
  const [dismissed, setDismissed] = useState(true); // start hidden to avoid SSR flash
  useEffect(() => {
    try {
      const v = sessionStorage.getItem("mv_fca_banner_dismissed");
      setDismissed(v === "true");
    } catch { setDismissed(false); }
  }, []);

  const close = () => {
    setDismissed(true);
    try { sessionStorage.setItem("mv_fca_banner_dismissed", "true"); } catch {}
  };

  if (dismissed) return null;

  return (
    <div
      data-testid="fca-top-banner"
      className="w-full text-white text-[12.5px] leading-snug"
      style={{ background: "#0A3B28" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-start gap-3">
        <Info size={16} className="mt-0.5 shrink-0" style={{ color: "var(--mv-gold)" }} />
        <div className="flex-1">
          <strong className="uppercase tracking-wide">Regulatory notice.</strong>{" "}
          Mavula Investment Ltd (UK Company No. 17368822) is <strong>not authorised or regulated by the Financial Conduct Authority</strong>. This is a structured property-purchase pathway — not a bank, not an investment product, and no returns or yields are offered.{" "}
          <a href="/legal-status" className="underline font-semibold hover:opacity-90">Read our Legal Status.</a>
        </div>
        <button
          type="button"
          onClick={close}
          aria-label="Dismiss notice"
          data-testid="fca-top-banner-close"
          className="shrink-0 rounded-full p-1 hover:bg-white/15"
        >
          <X size={14}/>
        </button>
      </div>
    </div>
  );
}
